import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationMessageService {

  constructor() {
  }

  getMessage(fieldLabel: string, errors: any) {
    if (!errors) { return; }

    if (errors.hasOwnProperty('required')) {
      return `${fieldLabel} is required`;
    }

    // Return server errors directly
    if (errors.hasOwnProperty('errorMessage')) {
      return errors.errorMessage;
    }

    return `${fieldLabel} is not valid`;
  }
}
